import { createContext } from 'react'

const defaultValue = {
  vendorId: null,
  networkId: null,
}

export const VendorContext = createContext(defaultValue)
